export const formatStartDate = (dateInput: string, useLongMonth: boolean = false) => {
  // Ensure the date is consistently formatted in a format like "YYYY-MM-DD" to "YYYY/MM/DD"
  const formattedDate = new Date(dateInput.replace(/-/g, '/'))
    .toLocaleString('en-us', {
      month: useLongMonth ? 'long' : 'short',
      day: 'numeric',
    })
    .split(' ');

  return {
    month: formattedDate[0],
    day: formattedDate[1],
  };
};
